import { render, staticRenderFns } from "./ResearchSectionComponents.vue?vue&type=template&id=45553148&"
import script from "./ResearchSectionComponents.vue?vue&type=script&lang=js&"
export * from "./ResearchSectionComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45553148')) {
      api.createRecord('45553148', component.options)
    } else {
      api.reload('45553148', component.options)
    }
    module.hot.accept("./ResearchSectionComponents.vue?vue&type=template&id=45553148&", function () {
      api.rerender('45553148', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSectionComponents.vue"
export default component.exports